import {
  AfterViewInit,
  Component,
  signal,
  ViewChild,
  ChangeDetectionStrategy,
} from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ToastService } from './shared/services/toast-service';
import { Spinner } from './core/components/spinner/spinner';
import { Toast } from './core/components/toast/toast';
import '@iframe-resizer/child';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, Toast, Spinner],
  templateUrl: './app.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './app.scss',
})
export class App implements AfterViewInit {
  @ViewChild(Toast) toastComponent!: Toast;
  @ViewChild(Spinner) spinnerComponent?: Spinner;

  protected readonly title = signal('instituto-online');

  constructor(private toastService: ToastService) {}

  ngAfterViewInit(): void {
    this.toastService.setToastComponent(this.toastComponent);
  }
}
